import { Star, BadgeCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const REVIEWS = [
  {
    name: "Giosafat A.",
    badge: "Appuntamento verificato",
    date: "12 dicembre 2024",
    text: "Dottore eccellente e professionale nonché bellissima persona. Essendo la prima visita ero molto in ansia ma fin da subito è stato capace di mettermi a mio agio e stemperare la tensione. Durante la visita è stato molto disponibile all'ascolto e attento rispondendo con chiarezza, fornendo spiegazioni accurate e dettagliate. Tutta la visita si è svolta in un clima molto rilassante e ha contribuito notevolmente a migliorare il mio stato d'animo e le mie preoccupazioni. Non posso che consigliare a chiunque il dott. Di Lorenzo!",
  },
  {
    name: "Giovanni Giuliano",
    badge: "Appuntamento verificato",
    date: "7 gennaio 2026",
    text: "Io ringrazio il medico per la sua bravura nel fare la visita! Dopo 20 anni finalmente mi sono convinto di effettuare la visita proctologica. E sono fiero di aver scelto come primo medico il dott. Di Lorenzo! Cortese, gentile, sembrava di conoscerlo da una vita! Complimenti vivissimi per la sua professionalità! Lo consiglio a tutti!",
  },
  {
    name: "Eliana C.",
    badge: "Recensione verificata",
    date: "13 giugno 2026",
    text: "Il numero 1 a Palermo. Operata con successo di fistola perianale a ferro di cavallo. Consigliatissimo.",
  },
];

export default function Reviews() {
  return (
    <section id="recensioni" className="relative py-28">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <p className="eyebrow">Dicono di me</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight max-w-3xl">
            Innumerevoli recensioni, <span className="italic text-gold">una sola promessa</span>
          </h2>
          <p className="mt-5 text-silver font-light text-lg max-w-2xl">
            Mi occupo di proctologia da più di 30 anni e il mio miglior biglietto da visita sono le
            parole dei miei pazienti: recensioni Google reali, dalla mia Clinica Weda a Palermo.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08} className="h-full">
              <div className="relative h-full rounded-3xl border border-white/10 bg-card p-8 flex flex-col transition-all duration-500 hover:border-gold/35">
                <div className="flex items-center justify-between gap-3">
                  <div className="flex gap-1 text-gold">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                    ))}
                  </div>
                  <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.12em] border border-sagelight/40 text-sagelight rounded-full px-3 py-1">
                    <BadgeCheck size={12} /> {r.badge}
                  </span>
                </div>
                <p className="text-silver leading-relaxed mt-5 flex-1">"{r.text}"</p>
                <div className="mt-6 pt-5 border-t border-white/10">
                  <p className="text-sm text-ivory/90">{r.name}</p>
                  <p className="text-xs text-silver/70 mt-1">Google · {r.date}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
